export default "__VITE_PUBLIC_ASSET__83cc2cec__"